import { render, staticRenderFns } from "./course-work-attachments-dialog.vue?vue&type=template&id=7f85df72&scoped=true"
import script from "./course-work-attachments-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./course-work-attachments-dialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./course-work-attachments-dialog.vue?vue&type=style&index=0&id=7f85df72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f85df72",
  null
  
)

export default component.exports